var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendDashboardIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.75513 2.11501L9.03513 4.25501C10.9551 5.21501 10.9551 6.78501 9.03513 7.74501L4.75513 9.88501C1.87513 11.325 0.700132 10.145 2.14013 7.27001L2.57513 6.40501C2.68513 6.18501 2.68513 5.82001 2.57513 5.60001L2.14013 4.73001C0.700132 1.85501 1.88013 0.675006 4.75513 2.11501Z",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.72021 6H5.42021",
    stroke: "#0D0D0D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendDashboardIcon);
export default __webpack_public_path__ + "static/media/send-dashboard-icon.81c81491cc9fe1b75e64e0b020919b8d.svg";
export { ForwardRef as ReactComponent };